import styled from "styled-components"
import { Checkbox } from 'ggx-componentlibrary/components/checkbox/checkbox.component'
import { DisplayedCheckbox } from 'ggx-componentlibrary/components/checkbox/checkbox.component.styles'
import SortingIcon from './sorting-icon.component'
import { COLOR } from 'ggx-componentlibrary/design/color/color.constants'
import { ContentBox } from 'ggx-componentlibrary/components/tooltip/tooltip.component.styles'

const Container = styled.div`
  position: relative;
  width: 100%;
  min-height: 282px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const StyledTable = styled.table`
  align-self: flex-start;
  width: 100%;
  height: 100%;
  th {
    padding: 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    ${ContentBox} {
      width: max-content;
      display: inline-flex;
      border-radius: 8px;
      border: 1px solid var(--grey_light, rgba(0, 0, 0, 0.10));
      box-shadow: 0px 3px 30px 0px rgba(0, 18, 26, 0.05), 0px 8px 24px 0px rgba(0, 18, 26, 0.06), 0px 4px 10px 0px rgba(0, 18, 26, 0.09);
    }
  }
  th[data-sortable=true] {
    cursor: pointer;
  }
  td {
    padding: 16px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
  th[data-checkbox], td[data-checkbox] {
    padding: 16px 0 16px 16px;
  }
  tr[data-checkbox="true"] td {
    background: ${COLOR.BLUE_LIGHTER};
  }
`

const StyledCheckbox = styled(Checkbox)`
  ${DisplayedCheckbox} {
    margin-right: 0;
  }
`

const StyledSortingIcon = styled(SortingIcon)`
  margin-left: 4px;
  cursor: pointer;
`


const Tooltip = styled.div`
  position: absolute;
  bottom: calc(100% + 2px);
  left: 0;
  display: none;
  width: 100%;
  justify-content: center;
`
const TooltipContent = styled.div`
  padding: 16px;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0px 3px 30px 0px rgba(0, 18, 26, 0.05), 0px 8px 24px 0px rgba(0, 18, 26, 0.06), 0px 4px 10px 0px rgba(0, 18, 26, 0.09);
  background-image: linear-gradient(0deg,#FFFFFF,#FFFFFF), linear-gradient(0deg,rgba(0,0,0,0.1),rgba(0,0,0,0.1));
  white-space: nowrap;
`

const StyledTHContent = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  padding: 16px;
  width: 100%;
  &:hover ${Tooltip} {
    display: flex;
  }
`

const LoadingContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.8);
`

export {
  Container,
  StyledTable,
  StyledCheckbox,
  Tooltip,
  TooltipContent,
  StyledTHContent,
  StyledSortingIcon,
  LoadingContainer,
}
